<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">

      <vx-card class="mb-8">
        <div class="vx-row mb-4 pr-1">
          <div class="vx-col sm:w1/1 w-full">
            <MeterNumberReport :org="org" :booklist="bookLists" :member="member"/>
            <vs-button color="primary" @click="submitMeter()">สร้างใบเสร็จ</vs-button>
          </div>
          <div class="vx-col sm:w1/1 w-full mt-2">
           <vx-card class="mt-4">
             <h5>{{ 'ใบเสร็จรอบบิลที่ '+ billIdNow.billId +' '+ billIdNow.name }}</h5>
             <h5 class="mt-2">{{ 'สมาชิก ' + billIdNow.user+' คน ' }}</h5>
           </vx-card>
          </div>
        </div>
      </vx-card>
      <vs-table noDataText="ไม่พบข้อมูล" :data="bookLists" class="table-custom mb-5">
        <template slot="thead">
          <vs-th>ลำดับที่</vs-th>
          <vs-th>ชื่อผู้ชำระค่าขยะ</vs-th>
          <vs-th>ประเภท</vs-th>
          <vs-th>เดือน</vs-th>
          <vs-th>ค่าขยะ</vs-th>
          <vs-th>รวม</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              <p class="product-name font-medium">{{ indextr + 1 }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium">{{ tr.M04  }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium">{{ `${tr.type} เดือน`  }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium">{{ tr.CB04  }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium">{{ typeOfNumber(tr.BA15) }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium">{{ tr.sum }}</p>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
  import moduleBillConfig from "@/store/billconfig/moduleBillConfig.js";
  import moduleInvoiceDate from "@/store/invoice-date/moduleInvoiceDate.js";
  import moment from "moment";
  import vSelect from 'vue-select';
  import moduleMember from "@/store/member/moduleMember.js";
  import moduleBookList from "@/store/booklist/moduleBookList.js";
  import moduleConfig from "@/store/config/moduleConfig.js";
  import modulePayby from "@/store/payby/modulePayby.js";
  import MeterNumberReport from '../pdf/MeterNumberReport.vue'
  export default {
    components: {
      vSelect,
      MeterNumberReport,
    },
    data() {
      return {
        billIdNext: {
          no: '',
          billId: '',
          name: '',
          year: ''
        },
        billIdNow: {
          billId: '',
          meter: '',
          user: '',
          name: ''
        },
        isActiveMember: false,
        radioBtn: '01',
        date: '',
        inputNumber: '',
        villageNo: '',
        telNumber: '',
        bookLists: [],
        checkBox: [],
        memberOpt: [],
        booklists: [],
        selectedMember: { label: 'ไม่พบข้อมูล', value: '', index: '', data: '' },
        selectedPayby: { label: '', value: '' },
        member: {
          _id: '',
          name: '',
          meter: '',
          address: '',
          numberIdentify: '',
          telephone: '',
          meterFirst: '',
          meterLast: ''
        },
        sumCheckbox: '',
        sumTable: [],
        userAll: [],
        indexMember: 0,
        sum: '',
        money: '',
        change: '',
        typePayment: '',
        disable01: false,
        disable02: true,
        disable03: true,
        thmonth: ['', 'มกราคม', 'กุมภาพันธ์', 'มีนาคม',
          'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน',
          'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
        payBySelect: [],
      }
    },
    watch: {
      radioBtn: {
        handler (val) {
          if (val === '01') {
            this.disable01 = false;
            this.disable02 = true;
            this.disable03 = true;
            this.villageNo = '';
            this.telNumber = '';
          }
          if (val === '02') {
            this.disable01 = true;
            this.disable02 = false;
            this.disable03 = true;
            this.inputNumber = '';
            this.telNumber = '';
          }
          if (val === '03') {
            this.disable01 = true;
            this.disable02 = true;
            this.disable03 = false;
            this.inputNumber = '';
            this.villageNo = '';
          }
        },
        deep: true
      },
    },
    computed: {
      org() {
        return this.$store.state.config.item;
      },
      // paybys() {
      //   let options = [];
      //   this.$store.state.payby.items.forEach(function (item) {
      //     options.push({
      //       'label': item.pb02,
      //       'value': item.pb01
      //     });
      //   });
      //   return options;
      // },
      // invoiceData() {
      //   const date = this.$store.state.invoiceDate.items[0];
      //   const formatDate = moment(date).format('DD/MM/YYYY')
      //   return formatDate;
      // }
    },
    methods: {
      async init() {
        const bill = await this.$store.state.billConfigs.item;
        this.bill = await this.$store.state.billConfigs.item;
        this.billIdNext = {
          no: bill.next.CB02,
          billId:  bill.next.CB01,
          name:  bill.next.CB04,
          year:  bill.next.CB03
        };
        this.billIdNow = {
          billId: bill.current.CB01,
          meter: bill.bookListCount,
          user: bill.current.CB06,
          name:  bill.current.CB04
        };
        this.$vs.loading.close()
        await this.getBookLists()
      },
      // async init() {
      //   this.selectedPayby = {
      //     'label': await this.$store.state.payby.items[0].pb02,
      //     'value': await this.$store.state.payby.items[0].pb01
      //   };
      // },
      onKeydownUser(e){
        if(e.keyCode == 13 || e.which == 13) { //Enter keycode
          this.submit()
        }
      },
      typeOfNumber(value) {
        const data = parseFloat(value).toFixed(2)
        return data;
      },
      splitDate(value, type) {
        const date = value.split('-');
        if (type === 'month') {
          return date[0];
        } else {
          return date[1];
        }
      },
      setMember(item) {
        this.indexMember = item.index;
        this.setUserData(this.userAll, item.index);
      },
      calculateBA(index) {
        if (this.checkBox[index]) {
          this.sumCheckbox += this.sumTable[index];
        } else {
          this.sumCheckbox -= this.sumTable[index];
        }
      },
      onKeydownMeter(e){
        if(e.keyCode == 13 || e.which == 13) { //Enter keycode
          this.submitMeter()
        }
      },
      submit() {
        this.$vs.loading();
        if (this.radioBtn === '01') {
          const user = { M01: this.inputNumber  };
          this.getUser(user);
        } else if (this.radioBtn === '02') {
          const user = { M05: this.villageNo };
          const bookLists = { B03: this.inputNumber, B10: '0', sortBy: 'B01:asc' };
          this.getUser(user);
        } else {
          const user = { M07: this.telNumber };
          const bookLists = { B03: this.inputNumber, B10: '0', sortBy: 'B01:asc' };
          this.getUser(user);
        }
      },
      async submitMeter() {
        this.$vs.loading();
        const user = JSON.parse(sessionStorage.getItem('vuex'));
        const staffId = user.owner.user.user._id;
        const body = {
          staff_id: staffId
        };
        await this.getCurrentBookList(body)
        this.$vs.loading.close();
        this.successDialog();
      },
      async getCurrentBookList(body){
        await this.$store.dispatch("bookLists/createAllBookList", body).then((res) => {
          if (res.status === 201) {
            this.getBookLists()
            this.$vs.loading.close();
          } else {
            this.noDataMember();
            this.$vs.loading.close();
          }
        }).catch((error) => {
          this.noDataMember();
          this.$vs.loading.close();
        });
      },
      setUserData(member, index) {
        // let type = '';
        // if (member[index].M17 !== undefined && member[index].M17 !== null && member[index].M17 !== '') {
        //   type = this.payBySelect[parseInt(member[index].M17)];
        // }
        this.member = {
          _id: member[index]._id,
          member_id: member[index].M01,
          area: member[index].M02,
          name: member[index].M04,
          meter: member[index].M27,
          address: member[index].M05+ ' ' + member[index].soi+ ' ' + member[index].road+ ' '+ member[index].M06,
          numberIdentify: member[index].M08,
          telephone:  member[index].M07,
          meterFirst: member[index].M09,
          meterLast: ''
        };
        let inputEl = this.$refs['inputMeter'].$el.querySelector('input')
        inputEl.focus()
        this.$vs.loading.close();
        const bookLists = { B03: member[index].M01, sortBy: 'B01:asc' };
        this.getBookLists(bookLists);
        if(member[index].M23 === '01'){
          this.isActiveMember = true
        }else{
          this.isActiveMember = false
          this.inActiveUserDialog()
        }
      },
      async getUser(payload) {
        await this.$store.dispatch("member/fetchDataListByFilter", payload).then((res) => {
          if (res.status === 200 && res.data.length !== 0) {
            const member = res.data;
            this.userAll = res.data;
            let options = [];
            for (let i = 0; i < member.length; i++) {
              options.push({
                'label': member[i].M04,
                'value': member[i].M01,
                'index': i,
                'data': member[i]
              });
            }
            this.memberOpt = options;
            this.selectedMember = {
              label: options[0].label,
              value:  options[0].value,
              data:  options[0].data
            };
            this.setUserData(member, 0);
          } else {
            this.noDataMember();
            this.$vs.loading.close();
          }
        }).catch((error) => {
          this.noDataMember();
          this.$vs.loading.close();
        });
      },
      async createBookLists(payload) {
        await this.$store.dispatch("bookLists/createAllBookList", ).then((res) => {
          if (res.status === 200 && res.data.length !== 0) {
          } else {
            this.noDataBookLists();
          }
          this.$vs.loading.close();
        }).catch((error) => {
          this.noDataBookLists();
          this.$vs.loading.close();
        });
      },
      async getBookLists() {
        this.$vs.loading();
        let payload = {};
        payload.B01 = this.billIdNow.billId;
        await this.$store.dispatch("bookLists/fetchPaymentDataListItems", payload).then((res) => {
          if (res.status === 200 && res.data.length !== 0) {
            let response = res.data;
            let array = [];
            for (let i = 0; i < response.length; i++) {
              let data = response[i];
              const sum = parseFloat(response[i].BA14) + parseFloat(response[i].BA15)
              data.sum = sum.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })
              array.push(data)
            }
            this.bookLists = array;
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        }).catch((error) => {
          this.$vs.loading.close();
        });
      },
      noDataMember() {
        this.memberOpt = [];
        this.selectedMember = {
          label: 'ไม่พบข้อมูล',
          value: '',
          data: ''
        };
        this.member = {
          _id: '',
          member_id: '',
          area: '',
          name: '',
          meter: '',
          address: '',
          numberIdentify: '',
          telephone:  '',
          meterFirst: '',
          meterLast: ''
        };
      },
      noDataBookLists() {
        this.bookLists = [];
        this.sumTable = [];
        this.sum = '';
        this.money = '';
        this.change = '';
        this.typePayment = '';
      },
      warningDialog(message) {
        this.$vs.dialog({
          type: 'alert',
          color: 'warning',
          title: `คำเตือน`,
          text: message,
          acceptText: 'ปิด'
        })
      },
      route(){
        this.$router.push('/user').catch(() => {})
      },
      inActiveUserDialog() {
        this.$vs.dialog({
          type: 'alert',
          color: 'danger',
          title: `ผิดพลาด`,
          text: 'รายนี้ยกเลิกใช้แล้ว',
          acceptText: 'ปิด'
        })
      },
      failDialog() {
        this.$vs.dialog({
          type: 'alert',
          color: 'danger',
          title: `ผิดพลาด`,
          text: 'จดมิเตอร์ไม่สำเร็จ',
          acceptText: 'ปิด'
        })
      },
      successDialog() {
        this.$vs.dialog({
          type: 'alert',
          color: 'success',
          title: `สำเร็จ`,
          text: 'จดมิเตอร์สำเร็จ',
          acceptText: 'ปิด',
        })
      }
    },
    async created() {
      // this.$vs.loading();
      // if (!moduleInvoiceDate.isRegistered) {
      //   this.$store.registerModule('invoiceDate', moduleInvoiceDate)
      //   moduleInvoiceDate.isRegistered = true
      // }
      if(!moduleMember.isRegistered) {
        this.$store.registerModule('member', moduleMember);
        moduleMember.isRegistered = true;
      }
      if (!moduleBookList.isRegistered) {
        this.$store.registerModule('bookLists', moduleBookList);
        moduleBookList.isRegistered = true;
      }
      if (!moduleConfig.isRegistered) {
        this.$store.registerModule('config', moduleConfig)
        moduleConfig.isRegistered = true
      }
      if (!moduleBillConfig.isRegistered) {
        this.$store.registerModule('billConfigs', moduleBillConfig);
        moduleBillConfig.isRegistered = true;
      }
      await this.$store.dispatch("area/fetchDataListItems");
      await this.$store.dispatch("billConfigs/fetchDataItem")
      await this.$store.dispatch("config/fetchDataItem");
      this.init();
      // if (!modulePayby.isRegistered) {
      //   this.$store.registerModule('payby', modulePayby);
      //   modulePayby.isRegistered = true
      // }
      // await this.$store.dispatch("payby/fetchDataListItems");
      // await this.$store.dispatch("invoiceDate/fetchDataListItems");
      // this.$vs.loading.close();
      // this.init();
    }
  }

</script>

<style lang="scss">
  .table-custom .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
    background: #8794a2;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: bold;
  }
</style>
